<template lang="pug">
  div
    Header(:content="headerContent")
    div.wrap-catalyst
      ModuleCatalyst(v-if="user && license" :user="user" :license="license")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-catalyst {
  width: 100%;
  background: $secondary_bg_color;
}
</style>

<script>
import database from '@/database'
import Header from '@/components/shared/Header.vue'
import ModuleCatalyst from '@/components/module/ModuleCatalyst'

export default {
  components: {
    Header, ModuleCatalyst
  },
  data () {
    return {
      user: null, license: null,
      headerContent: {
        title: 'カタリスト',
        left: {
          icon: 'mdi-close',
          to: '/search'
        }
      }
    }
  },
  async created () {
    this.user = await database.userCollection().findById(this.$route.params.uid)
    this.license = await database.licenseCollection().findById(this.user.license)
  }
}
</script>
